import { AxiosResponse } from 'axios';
import { useHttpClient } from '../components/infra/httpClient.component';

export const useCollectionService = () => {
    const httpClient = useHttpClient();

    const getAll = (): Promise<AxiosResponse<any, any>> => {
        return httpClient.get(`collection`);
    };

    const getFile = async (serverPath: string): Promise<Blob> => {
        const { data } = await httpClient.get(`collection/file`, {
            params: { path: serverPath },
            responseType: 'blob',
        });

        return data as Blob;
    };

    // Multi-page PDFs are shown page by page, rendered as images by the API
    const getPageCount = async (serverPath: string): Promise<number> => {
        const { data } = await httpClient.get(`collection/file/pages`, {
            params: { path: serverPath },
        });

        return data.pageCount as number;
    };

    const getPage = async (serverPath: string, page: number, width: number): Promise<Blob> => {
        const { data } = await httpClient.get(`collection/file/page`, {
            params: { path: serverPath, page, width },
            responseType: 'blob',
        });

        return data as Blob;
    };

    return { getAll, getFile, getPageCount, getPage };
}